
<template>
    <div class="content">
      <h1>HoboHat Games</h1>

      <p>
        HoboHat Games was a passion project I started with my friend a couple of years ago.
        We both love games and wanted to <strong>bring our own ideas to life</strong>,
        spending weekends building games we thought would be fun—both for us and our kids.
      </p>

      <p>
        Most of our games were inspired by what our <strong>children wanted to play</strong>,
        but we also experimented with different ideas.
        <strong>Ninja Blade</strong> was the exception—both of us have a huge passion for <strong>RPGs</strong>,
        so we wanted to create an <strong>immersive experience</strong> within Roblox.
      </p>

      <p>
        Over time, our games have accumulated <strong>over 1 million plays</strong>.
        Ironically, the game we spent <strong>the least amount of time on</strong>
        ended up being <strong>the most successful</strong>.
      </p>

      <p>
        More details on each game will be added soon, but for now, check out <strong>HoboHat Games on Roblox</strong>:
      </p>

      <p>
        <a href="https://www.roblox.com/communities/6296964/Hobohat-Games#!/about" target="_blank">
          Visit HoboHat Games on Roblox
        </a>
      </p>
    </div>
</template>
